var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMilk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 55,
    viewBox: "0 0 45 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54634 14.0538L9.30024 9.29993L14.0542 14.0538C15.5571 15.5568 16.3086 16.3083 16.7044 17.2639C17.1002 18.2195 17.1002 19.2822 17.1002 21.4077V53.4999H11.9002C6.99764 53.4999 4.54633 53.4999 3.02329 51.9769C1.50024 50.4538 1.50024 48.0025 1.50024 43.0999V21.4077C1.50024 19.2822 1.50024 18.2195 1.89607 17.2639C2.2919 16.3083 3.04338 15.5568 4.54634 14.0538Z",
    stroke: "#009595",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30029 9.30973V8.27104C9.30029 5.08837 9.30029 3.49703 10.2903 2.50831C11.2803 1.51958 12.8736 1.51958 16.0603 1.51958H30.4994C32.3361 1.51958 34.7192 1.2266 35.9469 2.90039C37.2509 4.6782 36.1363 7.12135 36.7013 9.08629C36.8731 9.68372 37.2973 10.1451 37.688 10.6134L43.1003 17.0999",
    stroke: "#009595",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1003 17.0999H43.1003V43.0999C43.1003 48.0025 43.1003 50.4538 41.5773 51.9768C40.0543 53.4999 37.6029 53.4999 32.7003 53.4999H17.1003",
    stroke: "#009595",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1003 30.0999C18.3384 31.3999 21.6331 31.3376 23.5664 30.825C24.9143 30.4676 26.3666 30.8869 27.2803 32.0861L29.0668 34.4309C30.0946 35.7798 31.6523 36.4203 33.1868 36.1249L35.4479 35.6896C36.6918 35.4502 37.929 36.0548 38.7758 37.1342C41.416 40.4999 43.1003 40.4999 43.1003 40.4999",
    stroke: "#009595",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMilk);
export default __webpack_public_path__ + "static/media/ic_milk.1afdb07eb2449bb3442286fbd4d36e86.svg";
export { ForwardRef as ReactComponent };